import { useThemeStore } from "@stores/theme.store";
import moment from "moment-timezone";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { LuCalendarX, LuFileText } from "react-icons/lu";

moment.locale("id");

type StatCardProps = {
  label: string;
  value: number;
  bg: string;
  text: string;
  ring: string;
};

const StatCard = ({ label, value, bg, text, ring }: StatCardProps) => (
  <div
    className="tw-flex-1 tw-rounded-2xl tw-py-4 tw-text-center"
    style={{ background: bg, border: `1.5px solid ${ring}` }}
  >
    <div className="tw-text-2xl tw-font-bold" style={{ color: text }}>
      {value}
    </div>
    <div className="tw-text-[10px] tw-font-semibold tw-mt-0.5" style={{ color: text }}>
      {label}
    </div>
  </div>
);

const Divider = () => <div className="tw-h-px" style={{ background: "#f1f1f1" }} />;

export const AbsenceDetailPage = () => {
  const { state } = useLocation();
  const { setHeader, setAppBar } = useThemeStore((s) => s);

  useEffect(() => {
    setAppBar({ title: "Detail Absensi", show: true, leading: "back" });
    setHeader({ buttonBack: true, filter: false, title: "Detail Absensi", image: false });
  }, [setHeader, setAppBar]);

  return (
    <div className="tw-px-4 tw-pt-2 tw-pb-20 tw-space-y-3">

      {/* Hero card */}
      <div className="card-body tw-text-center tw-py-6">
        <div
          className="tw-inline-flex tw-items-center tw-justify-center tw-rounded-3xl tw-w-16 tw-h-16 tw-mb-4"
          style={{ background: "#eff6ff" }}
        >
          <LuCalendarX className="tw-text-3xl tw-text-[#3b82f6]" />
        </div>
        <div className="tw-text-base tw-font-bold tw-text-text-primary">
          {moment(state?.tanggal ?? Date.now()).format("dddd, DD MMMM YYYY")}
        </div>
        <div className="tw-text-xs tw-text-text-secondary tw-mt-1">
          Rekap kehadiran harian
        </div>
      </div>

      {/* Stats grid */}
      <div className="card-body">
        <div className="tw-flex tw-items-center tw-gap-2 tw-mb-3">
          <div className="tw-w-1 tw-h-4 tw-rounded-full tw-bg-primary" />
          <span className="tw-text-xs tw-font-bold tw-text-text-secondary tw-uppercase tw-tracking-widest">
            Rincian Absensi
          </span>
        </div>
        <div className="tw-flex tw-gap-2">
          <StatCard
            label="Alpa"
            value={state?.alpa ?? 0}
            bg="#fef2f2"
            text="#dc2626"
            ring="#fecaca"
          />
          <StatCard
            label="Sakit"
            value={state?.sakit ?? 0}
            bg="#fffbeb"
            text="#d97706"
            ring="#fde68a"
          />
          <StatCard
            label="Izin"
            value={state?.ijin ?? 0}
            bg="#eff6ff"
            text="#2563eb"
            ring="#bfdbfe"
          />
        </div>
        <div className="tw-mt-2 tw-text-[10px] tw-text-text-secondary tw-text-center">
          dalam satuan jam pelajaran
        </div>

        {state?.catatan && state.catatan !== "-" && (
          <>
            <Divider />
            <div className="tw-pt-2.5 tw-pb-1">
              <div className="tw-flex tw-items-center tw-gap-1.5 tw-mb-1.5">
                <LuFileText className="tw-text-sm tw-text-text-secondary" />
                <span className="tw-text-xs tw-text-text-secondary">Catatan</span>
              </div>
              <p className="tw-text-sm tw-font-semibold tw-text-text-primary tw-leading-relaxed">
                {state.catatan}
              </p>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
